import type { Holerite, LancamentoHolerite } from '../../models/holerite.model';

export interface PaginaHolerite {
  itens: LancamentoHolerite[];
  final: boolean;
  eventos: boolean;
  texto?: string;
}

/** Reserva espaço para cabeçalho e, na última folha, bases, totais e recibo. */
export function paginarHolerite(h: Holerite, modo: 'completo' | 'simplificado'): PaginaHolerite[] {
  const linhas = (h.dados['textoLivre'] || '').trim() ? h.dados['textoLivre'].split(/\r?\n/).flatMap(linha => {
    const partes: string[] = [];
    for (let i = 0; i < Math.max(1, linha.length); i += 150) partes.push(linha.slice(i, i + 150));
    return partes;
  }) : [];
  const tokens = [
    ...h.lancamentos.map(item => ({ item, texto: undefined as string | undefined })),
    ...linhas.map(texto => ({ item: undefined as LancamentoHolerite | undefined, texto }))
  ];
  const altura = (parte: typeof tokens): number => {
    const eventos = parte.filter(t => t.item);
    return (eventos.length ? 36 : 0) + (parte.some(t => t.texto !== undefined) ? 30 : 0) + parte.reduce((total, t) => {
      if (!t.item) return total + 13;
      const l = t.item;
      const comprimentos = modo === 'completo'
        ? [[l.codigo, 24], [l.descricao || l.descricaoInternet, 85], [l.quantidade, 24], [l.unidade, 24]] as const
        : [[l.descricao || l.descricaoInternet || l.codigo, 145]] as const;
      const linhasEvento = Math.max(1, ...comprimentos.map(([valor, largura]) => String(valor || '').split('\n').reduce((n, linha) => n + Math.max(1, Math.ceil(linha.length / largura)), 0)));
      return total + 7 + linhasEvento * 13;
    }, 0);
  };
  const paginas: PaginaHolerite[] = [];
  const espacoFinal = modo === 'completo' ? 260 : 360;
  let restante = tokens;
  while (restante.length) {
    if (altura(restante) <= espacoFinal) {
      paginas.push(pagina(restante, true)); restante = []; break;
    }
    let fim = 1;
    if (altura(restante) <= 430) {
      while (fim < restante.length - 1 && altura(restante.slice(fim)) > espacoFinal) fim++;
    } else {
      while (fim < restante.length - 1 && altura(restante.slice(0, fim + 1)) <= 430) fim++;
    }
    paginas.push(pagina(restante.slice(0, fim), false)); restante = restante.slice(fim);
  }
  if (!paginas.length) paginas.push({ itens: [], eventos: true, final: true });
  return paginas;

  function pagina(parte: typeof tokens, final: boolean): PaginaHolerite {
    const itens = parte.flatMap(t => t.item ? [t.item] : []);
    const texto = parte.filter(t => t.texto !== undefined).map(t => t.texto).join('\n');
    return { itens, eventos: itens.length > 0 || (!h.lancamentos.length && !parte.length), final, ...(parte.some(t => t.texto !== undefined) ? { texto } : {}) };
  }
}
